// store/modules/shared.js
const state = {
    sharedData: {
        id: -1,
        model: "Model A",
        color: "Red",
        grade: "A",
        sources: "Source A",
        authorization: "Auth A",
        upsetPrice: 1000,
        purchaseChannel: "Online",
        qualityDesc: "Good",
        patch: "Batch 1",
        stickCode: "12345",
    },
    canbuyData: true,
};

const mutations = {
    setSharedData(state, newData) {
        state.sharedData = newData;
    },
    setCanbuyData(state, newData) {
        state.canbuyData = newData;
    },
};

const actions = {
    updateSharedData({ commit }, newData) {
        commit("setSharedData", newData);
    },
    updateCanbuyData({ commit }, newData) {
        commit("setCanbuyData", newData);
    },
};

const getters = {
    getSharedData: (state) => state.sharedData,
    getCanbuyData: (state) => state.canbuyData,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
